module.exports = __webpack_public_path__ + "media/images/app/colors/colors-red-d1a3b6babe78ff2643db1a01067fec20.webp";